import React from 'react';
import { Card, Button, Space, Typography, Divider, message } from 'antd';
import { PersistentStorage } from '../../utils/persistentStorage';

const { Title, Text } = Typography;

export const PersistenceTest: React.FC = () => {
  const showStorageStatus = () => {
    const products = PersistentStorage.get('products', []);
    const vendors = PersistentStorage.get('vendors', []);
    const stockMovements = PersistentStorage.get('stockMovements', []);
    
    message.info(`Storage Status: ${products.length} products, ${vendors.length} vendors, ${stockMovements.length} stock movements`);
  };

  const clearAllData = () => {
    PersistentStorage.clear();
    message.success('All persistent data cleared! Add some data and navigate between modules to test persistence.');
  };

  return (
    <Card title="🧪 Data Persistence Test" style={{ margin: '20px' }}>
      <Title level={4}>Bug Fix Verification</Title>
      <Text>
        This fix solves the data disappearing bug by using localStorage to persist data across navigation.
      </Text>
      
      <Divider />
      
      <Text strong>How to test:</Text>
      <ol>
        <li>Go to Inventory module → Add a test product</li>
        <li>Navigate to Procurement module → Add a test vendor</li>
        <li>Navigate back to Inventory → Your product should still be there</li>
        <li>Navigate back to Procurement → Your vendor should still be there</li>
      </ol>
      
      <Divider />
      
      <Space>
        <Button onClick={showStorageStatus} type="primary">
          Check Storage Status
        </Button>
        <Button onClick={clearAllData} danger>
          Clear All Data
        </Button>
      </Space>
      
      <Divider />
      
      <Title level={5}>Vendor vs Supplier Explanation:</Title>
      <Text>
        • <strong>Vendor</strong> = Broader term for any external business partner<br/>
        • <strong>Supplier</strong> = Specific type of vendor who provides goods/materials<br/>
        • Other vendor types: Service Provider, Contractor, Consultant
      </Text>
    </Card>
  );
}; 